import React from 'react';
import Modal from '@medflex/components/stories/Modal';
import Button from '@medflex/components/stories/Button';
import useLocationSearchParams from '@medflex/hooks/useLocationSearchParams';
import { showAlertToast, showSuccessToast } from '@medflex/components/stories/Toast';
import Logger from '@medflex/utils/Logger';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import getFullNameWithTitle from '@medflex/utils/getFullNameWithTitle';
import { trackEvent } from '@medflex/utils/Tracking';
import useSessionChat from '../../hooks/useSessionChat';

const SessionChatRemoveParticipantModal = () => {
  const { t } = useTranslation('messenger');
  const { id, participantId } = useLocationSearchParams();
  const history = useHistory();
  const { removeParticipant, chat } = useSessionChat({ id });

  const participant = chat && chat.participants.find(p => p.participantId === participantId);

  const handleClose = () => {
    history.goBack();
  };

  const handleSubmit = async event => {
    try {
      await removeParticipant({ id: participant.participantId });
      handleClose();
      showSuccessToast(t('SessionChatRemoveParticipantModal.successMessage'), null, {
        toastId: 'sessionChatRemoveParticipantSuccess',
      });
      trackEvent(event);
    } catch (e) {
      Logger.error(e);
      showAlertToast(t('SessionChatRemoveParticipantModal.unexpectedError'), null, {
        toastId: 'sessionChatRemoveParticipantFailed',
      });
    }
  };

  return (
    <Modal
      onClickCloseButton={handleClose}
      title={t('SessionChatRemoveParticipantModal.title')}
      showCloseButton
    >
      <div data-component="SessionChatRemoveParticipantModal">
        <div className="mb-6">
          {participant ? (
            t('SessionChatRemoveParticipantModal.description', {
              name: participant && getFullNameWithTitle({ id: participant.userId, ...participant }),
              title: chat.title,
              interpolation: { escapeValue: false },
            })
          ) : (
            <div className="animate-pulse flex flex-col">
              <div className="flex py-1 items-center">
                <div className="h-4 bg-slate-200 rounded w-full" />
              </div>
              <div className="flex py-1 items-center">
                <div className="h-4 bg-slate-200 rounded w-1/4" />
              </div>
            </div>
          )}
        </div>
        <footer className="flex justify-center">
          <Button onClick={handleSubmit} isLoading={!participant}>
            {t('SessionChatRemoveParticipantModal.submit')}
          </Button>
        </footer>
      </div>
    </Modal>
  );
};

export default SessionChatRemoveParticipantModal;
